import { render } from "./SuccessView.vue?vue&type=template&id=5a58742e"
import script from "./SuccessView.vue?vue&type=script&lang=js"
export * from "./SuccessView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__